import React from 'react';

const TrustedBy = () => {
  return (
    <section className="py-4 md:py-8 px-2 md:px-8" style={{ backgroundColor: '#F9F9F9' }}>
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-[17px] md:text-3xl font-normal text-gray-400">
          Trusted by <span className="font-bold text-gray-500">150+</span> startups & enterprises
        </h2>
      </div>
    </section>
  );
};

export default TrustedBy;